import { SVGProps, useId } from "react";

export default function CalendarIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, ...rest } = props;
  const uniqueId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M6.6665 1.66699V4.16699"
        stroke={`url(#paint0_linear_${uniqueId})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3335 1.66699V4.16699"
        stroke={`url(#paint1_linear_${uniqueId})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.9165 7.5752H17.0832"
        stroke={`url(#paint2_linear_${uniqueId})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.5 10.842V7.08366C2.5 4.58366 3.75 2.91699 6.66667 2.91699H13.3333C16.25 2.91699 17.5 4.58366 17.5 7.08366V14.167C17.5 16.667 16.25 18.3337 13.3333 18.3337H6.66667C3.75 18.3337 2.5 16.667 2.5 14.167"
        stroke={`url(#paint3_linear_${uniqueId})`}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0791 11.4167H13.0866"
        stroke={`url(#paint4_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0791 13.9167H13.0866"
        stroke={`url(#paint5_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99607 11.4167H10.0036"
        stroke={`url(#paint6_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.99607 13.9167H10.0036"
        stroke={`url(#paint7_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91209 11.4167H6.91957"
        stroke={`url(#paint8_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.91209 13.9167H6.91957"
        stroke={`url(#paint9_linear_${uniqueId})`}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id={`paint0_linear_${uniqueId}`}
          x1="7.1665"
          y1="1.66699"
          x2="7.1665"
          y2="4.16699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_${uniqueId}`}
          x1="13.8335"
          y1="1.66699"
          x2="13.8335"
          y2="4.16699"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint2_linear_${uniqueId}`}
          x1="9.99984"
          y1="7.5752"
          x2="9.99984"
          y2="8.5752"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint3_linear_${uniqueId}`}
          x1="10"
          y1="2.91699"
          x2="10"
          y2="18.3337"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint4_linear_${uniqueId}`}
          x1="13.0828"
          y1="11"
          x2="13.0828"
          y2="11.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint5_linear_${uniqueId}`}
          x1="13.0828"
          y1="13.5"
          x2="13.0828"
          y2="14.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint6_linear_${uniqueId}`}
          x1="9.99982"
          y1="11"
          x2="9.99982"
          y2="11.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint7_linear_${uniqueId}`}
          x1="9.99982"
          y1="13.5"
          x2="9.99982"
          y2="14.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint8_linear_${uniqueId}`}
          x1="6.91583"
          y1="11"
          x2="6.91583"
          y2="11.8333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`paint9_linear_${uniqueId}`}
          x1="6.91583"
          y1="13.5"
          x2="6.91583"
          y2="14.3333"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
